"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.analysis = exports.questions = void 0;

var _screeners = require("../../screeners");

var _utils = require("../../screeners/utils");

var surveyscreeners = [_utils.screeners.WHO5, _utils.screeners.STRESS_STUDENTS, _utils.screeners.PERSONALISATION];
var causalAnalysisQuestionScale = ["Low or failing grades", "Low confidence in myself or abilities", "Lacking information or resources", "Feeling cynical/pessimistic", "Lack of teacher support", "Lack of parental support", "Financial stress", "Work/job requirements", "Loneliness", "Stressful life events", "Uninterested/disengaged with degree/subjects"];
var questions = (0, _screeners.expandscreeners)([_utils.screeners.WHO5, {
  extraText: "In the past month,",
  batteryId: "WHO5",
  type: "multiSkip",
  meta: {
    answerLabel: "My challenges are...",
    skipLabel: "I have no challenges at uni",
    responsePrefix: "My challenges are: ",
    noResponsePrefix: "I have no challenges at uni"
  },
  prompt: "In the past month have any of the following made it hard for you to study effectively",
  options: causalAnalysisQuestionScale
}, _utils.screeners.STRESS_STUDENTS, _utils.screeners.PERSONALISATION]);
exports.questions = questions;

var analysis = function analysis(answers, bonus) {
  if (!answers) return null;
  var results = {};
  surveyscreeners.forEach(function (screener) {
    var filteredQuestions = questions.filter(function (question) {
      return question.batteryId === screener;
    });
    results[screener] = (0, _screeners.extractResults)(filteredQuestions, answers[screener], screener); // answer: {WHO5: Array, STRESS: Array}

    filteredQuestions.forEach(function (q, i) {
      if (!q.key) return;
      results[q.key] = q.eval(answers[screener][i]);
    });
  });
  return results;
};

exports.analysis = analysis;